// extracted by mini-css-extract-plugin
export default {"main-div":"article_main-div__-Vry-","cta-button":"article_cta-button__PofWS"};